import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {t} from 'i18next';
import {IPresentation} from '../../../../../incase-domain/presentation';
import {IPaginatedResult} from '../../../../../incase-domain/search';
import {PLAYER_HOST, PLAYER_PRES_ID_QUERY} from '../../../../../incase-domain/online';
import GridCard from '../../../GridCard';
import TooltipWrapper, {TooltipModifiers} from '../../../common/TooltipWrapper';
import {TOOLTIP_DELAY} from '../../../../../constants';
import {exportPresentationAction} from '../../../../../store/actions/presentation';
import {DateTimeFormat, formatDateTime} from '../../../../../utils/dateTimeUtils';
import {exportingPresentationsSelector} from '../../../../../store/selectors/presentation.selectors';
import Button from '../../../../../incase-domain/components/button/Button';

interface FeedListProps {
    presentationFeed: IPaginatedResult<IPresentation>;
}
function FeedList({presentationFeed}: FeedListProps): JSX.Element {
    const dispatch = useDispatch();

    const exportingPresentations = useSelector(exportingPresentationsSelector);

    function generatePresUrl(presentation: IPresentation): string {
        const DEFAULT_PARAM_VAL = 'connection';
        const baseUrl = `${PLAYER_HOST}?${PLAYER_PRES_ID_QUERY}=${presentation._id}`;

        const params = presentation.requestParams
            ?.filter((param) => param.required)
            .map((param) => {
                return `${param.key}=${DEFAULT_PARAM_VAL}`;
            });

        if (params?.length) {
            return `${baseUrl}&${params.join('&')}`;
        }

        return baseUrl;
    }

    return (
        <>
            <div className="l-grid">
                {presentationFeed.content.map((presentation) => (
                    <div key={presentation._id} className="l-col:3 md:4 sm:12 xs:12">
                        <GridCard
                            imgSrc={presentation.firstSlidePreview}
                            onClick={() => window.open(generatePresUrl(presentation), '_blank')}
                        >
                            <div className="l-grid l-grid--noGaps">
                                <div className="l-col:9">
                                    <TooltipWrapper
                                        tooltipClassModifiers={
                                            presentation.name && presentation.name.length > 20
                                                ? TooltipModifiers.MULTILINE_TOOLTIP
                                                : TooltipModifiers.HIDE_SHORT_TOOLTIP
                                        }
                                        id={presentation._id}
                                        content={presentation.name as string}
                                        delayShow={TOOLTIP_DELAY}
                                    >
                                        <div
                                            className="u-pointer u-w-fc presTitleGrid"
                                            onClick={() => window.open(generatePresUrl(presentation), '_blank')}
                                        >
                                            {presentation.name}
                                        </div>
                                    </TooltipWrapper>
                                </div>
                                <div className="l-col:3 u-flex u-h-right u-v-center">
                                    <TooltipWrapper id="presentation-download" content={<>{t('presEditPage.subNavBar.download')}</>}>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            square
                                            leading="solar:download-minimalistic-linear"
                                            onClick={() => {
                                                dispatch(exportPresentationAction(presentation._id));
                                            }}
                                            disabled={exportingPresentations.includes(presentation._id)}
                                        />
                                    </TooltipWrapper>
                                </div>
                                <div className="l-col:12 u-flex u-h-between u-v-center">
                                    {presentation.userEmail}
                                    <span>{formatDateTime(String(presentation.lastModified), DateTimeFormat.DATE)}</span>
                                </div>
                            </div>
                        </GridCard>
                    </div>
                ))}
            </div>
        </>
    );
}

export default FeedList;
